var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0229 15.2172C27.0229 14.1622 26.9356 13.1477 26.7736 12.1738H13.8599V17.9292H21.2391C20.9213 19.789 19.9552 21.3648 18.5031 22.4198V26.153H22.9344C25.5271 23.5628 27.0229 19.7484 27.0229 15.2172Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8595 29.7575C17.5616 29.7575 20.6654 28.4252 22.934 26.1528L18.5027 22.4196C17.2749 23.3124 15.7043 23.8399 13.8595 23.8399C10.2883 23.8399 7.26555 21.2226 6.18733 17.7058H1.60645V21.5607C3.86261 26.4234 8.49958 29.7575 13.8595 29.7575Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18723 17.7058C5.913 16.8131 5.75719 15.8595 5.75719 14.8789C5.75719 13.8983 5.913 12.9447 6.18723 12.0519V8.19702H1.60635C0.677711 10.2056 0.147949 12.478 0.147949 14.8789C0.147949 17.2798 0.677711 19.5521 1.60635 21.5608L6.18723 17.7058Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8595 5.91789C15.8726 5.91789 17.68 6.66859 19.101 8.14293L23.0337 3.87546C20.6592 1.47458 17.5554 0.000244141 13.8595 0.000244141C8.49958 0.000244141 3.86261 3.33442 1.60645 8.19703L6.18732 12.052C7.26555 8.53518 10.2883 5.91789 13.8595 5.91789Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.d7bf06f8b691f64e78bbe2eed6ff3e78.svg";
export { ForwardRef as ReactComponent };